var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ObjectLikeButtons"},[_c('ObjectLikeButtonsWrapper',{attrs:{"status":_vm.status,"id":_vm.id},scopedSlots:_vm._u([{key:"dislike",fn:function(ref){
var active = ref.active;
var onClick = ref.onClick;
return [_c('button',{class:['ObjectLikeButtons__dislike', {'ObjectLikeButtons__dislike--active': active}],on:{"click":onClick}},[_c('DislikeIcon'),_c('span',{staticClass:"text"},[_vm._v("Не нравится")])],1)]}},{key:"like",fn:function(ref){
var active = ref.active;
var onClick = ref.onClick;
return [_c('button',{class:['ObjectLikeButtons__like', {'ObjectLikeButtons__like--active': active}],on:{"click":onClick}},[_c('LikeIcon'),_c('span',{staticClass:"text"},[_vm._v("Нравится")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }